import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoDeclaracionJuradaCeseActividadObjetiva = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoDeclaracionJuradaCeseActividadObjetiva = () => {
  const [loadingGetInfoDeclaracionJuradaCeseActividadObjetiva, setLoadingGetInfoDeclaracionJuradaCeseActividadObjetiva] = useState(false);
  const [successGetInfoDeclaracionJuradaCeseActividadObjetiva, setSuccessGetInfoDeclaracionJuradaCeseActividadObjetiva] = useState(false);
  const [errorGetInfoDeclaracionJuradaCeseActividadObjetiva, setErrorGetInfoDeclaracionJuradaCeseActividadObjetiva] = useState<any>(null);
  const [dataGetInfoDeclaracionJuradaCeseActividadObjetiva, setDataGetInfoDeclaracionJuradaCeseActividadObjetiva] = useState<any>(null);

  const [statusGetInfoDeclaracionJuradaCeseActividadObjetiva, setStatusGetInfoDeclaracionJuradaCeseActividadObjetiva] =
    useState<StatusGetInfoDeclaracionJuradaCeseActividadObjetiva>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoDeclaracionJuradaCeseActividadObjetiva = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoDeclaracionJuradaCeseActividadObjetiva(true);
    setSuccessGetInfoDeclaracionJuradaCeseActividadObjetiva(false);
    setErrorGetInfoDeclaracionJuradaCeseActividadObjetiva(null);

    try {
      const res = await apiRecord.getInfoSolicitudDeclaracionJuradaObjetiva(userId);

      setStatusGetInfoDeclaracionJuradaCeseActividadObjetiva({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoDeclaracionJuradaCeseActividadObjetiva(true);
      setDataGetInfoDeclaracionJuradaCeseActividadObjetiva(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoDeclaracionJuradaCeseActividadObjetiva({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoDeclaracionJuradaCeseActividadObjetiva(err);
      console.error("Error en getInfoDeclaracionJuradaCeseActividadObjetiva:", err);

      throw err;

    } finally {
      setLoadingGetInfoDeclaracionJuradaCeseActividadObjetiva(false);
    }
  };

  return {
    getInfoDeclaracionJuradaCeseActividadObjetiva,
    loadingGetInfoDeclaracionJuradaCeseActividadObjetiva,
    successGetInfoDeclaracionJuradaCeseActividadObjetiva,
    errorGetInfoDeclaracionJuradaCeseActividadObjetiva,
    dataGetInfoDeclaracionJuradaCeseActividadObjetiva,
    statusGetInfoDeclaracionJuradaCeseActividadObjetiva
  };
};

export default useGetInfoDeclaracionJuradaCeseActividadObjetiva;
